// Auto-add free gift by variant ID from URL (?vid=...) and open Eurus cart drawer
(function () {
  const params = new URLSearchParams(location.search);
  const variantId = params.get('vid');
  const qty = parseInt(params.get('qty') || '1', 10);
  const open = params.get('open') !== '0';
  const statusEl = document.getElementById('gift-status');

  function setStatus(text, type) {
    if (!statusEl) return;
    statusEl.textContent = text;
    if (type) {
      try { statusEl.setAttribute('data-status', String(type)); } catch (e) {}
    }
  }

  if (!variantId) {
    setStatus('Missing gift configuration (no variant ID).', 'error');
    return;
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to read cart');
    return res.json();
  }

  async function addGift(id, quantity) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id, quantity })
    });
    if (!res.ok) {
      let detail = '';
      try { detail = await res.text(); } catch (e) {}
      throw new Error(detail || 'Add failed');
    }
    return res.json();
  }

  function openEurusDrawer() {
    if (!open) return;
    // Preferred: explicit hook added to header cart icon
    var trigger = document.querySelector('[data-eurus-cart-trigger="true"]');
    if (trigger) { trigger.click(); return; }
    // Fallback guesses supported by Eurus/modern themes
    var guesses = [
      'button[aria-controls="minicart"]',
      'button[aria-controls="CartDrawer"]',
      '.header__icon--cart',
      '.site-header__cart',
      '.js-open-cart',
      '[data-drawer="cart"]'
    ];
    for (var i = 0; i < guesses.length; i++) {
      var el = document.querySelector(guesses[i]);
      if (el) { el.click(); return; }
    }
    try { document.dispatchEvent(new CustomEvent('cart:open')); } catch (e) {}
    setTimeout(function () { location.href = '/cart'; }, 700);
  }

  (async function run() {
    try {
      setStatus('Checking your cart…', 'info');
      const cart = await getCart();
      const already = Array.isArray(cart.items) && cart.items.some(function (li) { return String(li.id) === String(variantId); });
      if (already) {
        setStatus('Your free gift is already in your cart!', 'info');
        openEurusDrawer();
        return;
      }

      setStatus('Adding your free gift…', 'info');
      const quantity = Number.isFinite(qty) && qty > 0 ? qty : 1;
      await addGift(variantId, quantity);
      setStatus('Free gift added!', 'success');
      openEurusDrawer();
    } catch (err) {
      console.error(err);
      var msg = String(err && err.message || '').toLowerCase();
      if (msg.includes('sold out') || msg.includes('unavailable') || msg.includes('not enough')) {
        setStatus('Oops—this gift is out of stock. Your unique discount still applies at checkout.', 'error');
      } else {
        setStatus('We couldn’t add the gift automatically. You can continue shopping or view your cart.', 'error');
      }
    }
  })();
})();


